import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { Globals } from '../app/globals'
import { TabMenuModule } from 'primeng/tabmenu';
import { MenuItem } from 'primeng/api';
import { SecurityService } from './Services/SecurityService';
import { UserService } from './Services/UserService';
import { ISPEDSecurityUser } from './Models/ISPEDSecurityUser';
import { Logger, Account, CryptoUtils, ServerError } from 'msal';
import { Observable, throwError, of } from "rxjs";
import { CookieService } from 'ngx-cookie-service';
import { Message } from 'primeng/api';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { HttpResponseBase } from '@angular/common/http';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'app';
  _globals: Globals
  _securityService: SecurityService
  _userService: UserService
  topMenuItems: MenuItem[];
  topMenuItemsDisabled: MenuItem[];
  isLoggedIn: boolean;
  isIframe: boolean;
  callLoginSuccess: boolean;
  user: string;
  subscription;
  timeStamp: Date;
  messages: Message[];
  _emailaddress: string;
  spedSecurityUser: ISPEDSecurityUser;

  singleUseLoginId: string;
 
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private globals: Globals,
    private securityService: SecurityService,
    private userService: UserService,
    private activatedroute: ActivatedRoute,
    private cookieServices: CookieService
  )
  {
    this._globals = globals;
    this._securityService = securityService;
    this._userService = userService;
  }

  ngOnInit() {
    this.isIframe = window !== window.parent && !window.opener;

    this._userService.userLoggedIn().subscribe(res => {
      this._globals.spedSecurityUser = res;
      this.isLoggedIn = !!this._globals.spedSecurityUser;
      if (this.isLoggedIn) {
        this.user = this._globals.spedSecurityUser.userNameEmail;
        this._globals.spedSecurityUsername = this._globals.spedSecurityUser.userNameEmail;
        this.FinalizeAuthentication(this._globals.spedSecurityUser);
      }
    },
      err => {
        let error = err as HttpErrorResponse;
        if (error.error == "User Is Not Logged In") {
          let errorMessage: Message = { severity: 'warning', summary: 'User Is Not Logged In' };
          this.addMessage(errorMessage);
        } else {
          this.errorHandler(err)
        }
      }
    );
  }

  FinalizeAuthentication(spedSecurityUser: ISPEDSecurityUser) {
    this.globals.spedSecurityUser = spedSecurityUser;
    this.globals.securityCanDocumentBeEdited = false;
    this.globals.securityCanUserEdit = false;
    this.globals.canUserEditAllActivityLogs = false;
    this.globals.canUserCancelIep = false;

    const expirationDateTime = new Date();
    expirationDateTime.setHours(expirationDateTime.getHours() + 8);
    const secureFlag = true;
    var userName = spedSecurityUser.firstName + ' ' + spedSecurityUser.lastName;

    switch (this.globals.spedSecurityUser.roleName) {
      case '':                  // no assigned role
      case 'Auditor1':           // Auditors cannot create or edit IEP's / AP's
      case 'Auditor2':           // Auditors cannot create or edit IEP's / AP's
      case 'ParaEd':            // ParaEd's cannot create or edit IEP's / AP's
      case 'ParaEd + Logging':  // ParaEd's cannot create or edit IEP's / AP's, This role however can log services
      case 'ReadOnly':          // ReadOnly users cannot create or edit IEP's / AP's
        this.buildMenus();
        break;
      case 'SiteAdministrator':
      case 'Clerical':
      case 'Contractor':
      case 'Nurse':
      case 'Provider':
      case 'SELPA':
      case 'SysAdmin':
        this.globals.securityCanUserEdit = true;
        this.buildMenus();
        break;
    }

    switch (this.globals.spedSecurityUser.roleName) {
      case 'SiteAdministrator':
        this.globals.includeInactiveStudents = true;
        this.globals.canUserCancelIep = true;
        break;
      case 'SELPA':
        this.globals.includeInactiveStudents = true;
        this.globals.canUserEditAllActivityLogs = true;
        this.globals.canUserCancelIep = true;
        break;
      case 'Provider':
        this.globals.includeInactiveStudents = false;
        if (this.globals.spedSecurityUser.isSubstitute) {
          this.topMenuItems.push({ label: 'Substitute', routerLink: ["/substitute"] });
          this.topMenuItemsDisabled.push({ label: 'Substitute', disabled: true });
        }
        break;
      case 'SysAdmin':
        this.globals.includeInactiveStudents = true;
        this.globals.canUserEditAllActivityLogs = true;
        this.globals.canUserCancelIep = true;
        this.topMenuItems.push({ label: 'CALPADS', routerLink: ["/calpads"] });
        this.topMenuItems.push({ label: 'Maintenance', routerLink: ["/maintenance"] });
        this.topMenuItemsDisabled.push({ label: 'CALPADS', disabled: true });
        this.topMenuItemsDisabled.push({ label: 'Maintenance', disabled: true });
        break;
      default:
        this.globals.includeInactiveStudents = false;
        break;
    }

  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.topMenuItems = null;
      this.topMenuItemsDisabled = null;
      this._globals.iepApMenuItems = null;
      this._globals.iepApMenuItemsDisabled = null;
    }
  }

  buildMenus() {
    this.topMenuItems = [
      { label: 'My Dashboard', routerLink: ["/dashboard"] },
      { label: 'Service Documentation', routerLink: ["/service-documentation"] },
      { label: 'Single Page Service Documentation', routerLink: ["/singlepageservicedocumentation"] },
      { label: 'IEP/AP', routerLink: ["/iep-ap"] },
      { label: 'Activity Log', routerLink: ["/activitylog"] },
      { label: 'Student Services', routerLink: ["/student-services"] },
      { label: 'Reports', routerLink: ["/reports"] }
    ];

    this.topMenuItemsDisabled = [
      { label: 'My Dashboard', disabled: true },
      { label: 'Service Documentation', disabled: true },
      { label: 'Single Page Service Documentation', disabled: true },
      { label: 'IEP/AP', disabled: true},
      { label: 'Activity Log', disabled: true},
      { label: 'Student Services', disabled: true },
      { label: 'Reports', disabled: true }
    ];

    this._globals.iepApMenuItems = [
      { label: 'Student Search', command: (event: Event) => { this._globals.selectedIepMenuItem(0) } }
    ];
    document.getElementById('userNotLoggedInSpan').style.visibility = 'hidden';
    document.getElementById('userLoggedInSpan').style.visibility = 'visible';
    document.getElementById('menuDiv').style.visibility = 'visible';
    document.getElementById('containerDiv').style.visibility = 'visible';
  }

  buildTeacherMenu() {
    this.topMenuItems = [
      { label: 'IEP Summary', routerLink: ["/iep-summary"] }
    ];
  }

  login() {
    this.clearMessages();
  }

  logout() {
    this.clearMessages();
    document.getElementById('menuDiv').style.visibility = 'hidden';
    document.getElementById('containerDiv').style.visibility = 'hidden';
    document.getElementById('userLoggedInSpan').style.visibility = 'hidden';
    document.getElementById('userNotLoggedInSpan').style.visibility = 'visible';
    this.isLoggedIn = false;
    this._userService.logOut();
  }

  errorHandler(error: Response) {
    this.timeStamp = new Date();
    console.log(error);
    let errorMessage: Message = { severity: 'error', summary: 'An unexpected error occurred: ', detail: error.statusText + ' at: ' + this.timeStamp.toLocaleTimeString() };
    this.addMessage(errorMessage);
    return Observable.throw(error);
  }

  addMessage(msg: Message) {
    if (!this.messages)
      this.messages = [] as Message[];
    this.messages.push(msg);
  }

  clearMessages() {
    this.messages = [] as Message[];
  }

}
